import { TABLET_BREAK } from '@community_dev/pixels'
import React, { type JSX } from 'react'

import { SimpleLayout } from 'layouts/SimpleLayout'
import 'styled-components'

type BoxFormLayoutProps = {
  children: React.ReactNode
}

export class BoxFormLayout extends React.PureComponent<BoxFormLayoutProps> {
  render(): JSX.Element {
    return (
      <SimpleLayout>
        <div
          css={`
            padding: 12px;
            width: 100%;
            max-width: 512px;
          `}
        >
          <div
            css={`
              width: 100%;
              padding-top: 24px;
              @media (min-width: ${TABLET_BREAK}) {
                padding-top: 60px;
              }
            `}
          >
            {this.props.children}
          </div>
        </div>
      </SimpleLayout>
    )
  }
}
